function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M20.3804 11.0353L9.26909 14.1648C9.1745 14.1907 9.09019 14.2451 9.02763 14.3206C8.96507 14.3961 8.92731 14.4891 8.91949 14.5868C8.91167 14.6845 8.93417 14.7823 8.98393 14.8668C9.03369 14.9513 9.10828 15.0184 9.19755 15.059L14.3002 17.4732C14.4001 17.5195 14.4804 17.5998 14.5267 17.6997L16.9409 22.8023C16.9815 22.8916 17.0486 22.9662 17.1331 23.016C17.2176 23.0657 17.3154 23.0882 17.4131 23.0804C17.5108 23.0726 17.6038 23.0348 17.6793 22.9723C17.7548 22.9097 17.8092 22.8254 17.8351 22.7308L20.9646 11.6195C20.9883 11.5384 20.9898 11.4524 20.9689 11.3706C20.9479 11.2887 20.9053 11.214 20.8456 11.1543C20.7859 11.0946 20.7112 11.052 20.6293 11.031C20.5475 11.0101 20.4615 11.0116 20.3804 11.0353V11.0353Z",
  stroke: "white",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M14.4258 17.5739L20.7209 11.2788",
  stroke: "white",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref4 = /*#__PURE__*/React.createElement("circle", {
  cx: 16.0003,
  cy: 16.0001,
  r: 12.5902,
  stroke: "white",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

function SvgPaperPlaneTiltWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaperPlaneTiltWhite);
export default __webpack_public_path__ + "static/media/paper-plane-tilt-white.28abd4ba.svg";
export { ForwardRef as ReactComponent };